import React, { useState } from "react";
import SimpleBar from 'simplebar-react';
import { useLocation } from "react-router-dom";
import { CSSTransition } from 'react-transition-group';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faGlobeAmericas, faSignOutAlt, faTimes, faUsers, faImage, faFlag, faHome, faChevronDown, faChevronRight } from "@fortawesome/free-solid-svg-icons";
import { Nav, Image, Button, Navbar } from '@themesberg/react-bootstrap';
import { Link, useHistory } from 'react-router-dom';
import { useClerk } from '@clerk/react';

import { Routes } from "../routes";
import ProfilePicture from "../assets/img/team/profile-picture-3.jpg";
import GoLocalBrandMark from "./GoLocalBrandMark";

export default (props = {}) => {
  const location = useLocation();
  const { pathname } = location;
  const history = useHistory();
  const { signOut } = useClerk();
  const [show, setShow] = useState(false);
  const [expandedItems, setExpandedItems] = useState({});
  const showClass = show ? "show" : "";

  const onCollapse = () => setShow(!show);

  const toggleExpanded = (key) => {
    setExpandedItems(prev => ({
      ...prev,
      [key]: !prev[key]
    }));
  };

  const CollapsableNavItem = (props) => {
    const { eventKey, title, icon, children = null } = props;
    const isExpanded = expandedItems[eventKey];
    const isActive = pathname.indexOf(eventKey) !== -1;
    
    return (
      <div className="nav-item-wrapper">
        <div 
          className={`nav-item-collapsable ${isActive ? 'active' : ''}`}
          onClick={() => toggleExpanded(eventKey)}
        >
          <span className="nav-content">
            <span className="sidebar-icon">
              <FontAwesomeIcon icon={icon} />
            </span>
            <span className="sidebar-text">{title}</span>
          </span>
          <FontAwesomeIcon 
            icon={isExpanded ? faChevronDown : faChevronRight} 
            className="collapse-icon"
          />
        </div>
        {isExpanded && (
          <div className="nav-submenu">
            {children}
          </div>
        )}
      </div>
    );
  };

  const NavItem = (props) => {
    const { title, link, external, target, icon, image, isSubmenu = false } = props;
    const isActive = link === pathname;
    const linkProps = external ? { href: link } : { as: Link, to: link };

    return (
      <Nav.Item 
        className={`custom-nav-item ${isActive ? 'active' : ''} ${isSubmenu ? 'submenu-item' : ''}`} 
        onClick={() => setShow(false)}
      >
        <Nav.Link {...linkProps} target={target}>
          <span className="nav-content">
            {icon ? (
              <span className="sidebar-icon">
                <FontAwesomeIcon icon={icon} />
              </span>
            ) : null}
            {image ? (
              <Image src={image} width={20} height={20} className="sidebar-icon svg-icon" />
            ) : null}
            <span className="sidebar-text">{title}</span>
          </span>
          {isActive && <div className="active-indicator" />}
        </Nav.Link>
      </Nav.Item>
    );
  };

  const handleLogout = () => {
    signOut(() => history.push(Routes.Signin.path));
  };

  return (
    <>
      <style>{`
        /* Sidebar Base Styles */
        .sidebar {
          background: linear-gradient(180deg, #1e293b 0%, #0f172a 100%) !important;
          width: 260px;
          height: 100vh;
          position: fixed;
          left: 0;
          top: 0;
          z-index: 1040;
          box-shadow: 4px 0 12px rgba(0, 0, 0, 0.15);
          overflow-x: hidden;
        }

        .sidebar-inner {
          padding: 1.5rem 0 !important;
        }

        /* Logo Section — shared GoLocalBrandMark, centered in rail */
        .sidebar-logo {
          padding: 0 0.75rem;
          margin-bottom: 2rem;
          display: flex;
          align-items: center;
          justify-content: center;
          width: 100%;
          overflow: visible;
        }

        .sidebar-logo .golocal-brand {
          align-items: center;
        }

        .sidebar-logo .golocal-wordmark-stack {
          align-items: flex-start;
          text-align: left;
        }

        .navbar-brand .golocal-brand {
          align-items: center;
        }

        .navbar-brand .golocal-wordmark-stack {
          align-items: flex-start;
        }

        .sidebar-logo .golocal-wordmark-tagline,
        .navbar-brand .golocal-wordmark-tagline {
          color: rgba(226, 232, 240, 0.55);
        }

        @media (max-width: 380px) {
          .navbar-brand .golocal-wordmark {
            font-size: 1.05rem;
          }
          .navbar-brand .golocal-wordmark-admin {
            font-size: 0.625rem;
          }
          .navbar-brand .golocal-wordmark-tagline {
            font-size: 0.5rem;
            letter-spacing: 0.1em;
          }
          .navbar-brand .golocal-logo-wrap {
            width: 32px;
            height: 32px;
          }
        }

        /* User Card (Mobile) */
        .user-card {
          padding: 0 1.5rem 1.5rem;
          border-bottom: 1px solid rgba(255, 255, 255, 0.1);
          margin-bottom: 1rem;
        }

        .user-avatar {
          width: 48px;
          height: 48px;
          border-radius: 50%;
          border: 2px solid rgba(129, 140, 248, 0.5);
        }

        .user-card h6 {
          color: #f1f5f9;
          font-weight: 600;
          margin-bottom: 0.5rem;
        }

        .user-card .btn-secondary {
          background: rgba(255, 255, 255, 0.1);
          border: 1px solid rgba(255, 255, 255, 0.2);
          color: #f1f5f9 !important;
          font-size: 0.8rem;
          padding: 0.4rem 0.8rem;
          transition: all 0.3s ease;
        }

        .user-card .btn-secondary:hover {
          background: rgba(255, 255, 255, 0.15);
          border-color: rgba(255, 255, 255, 0.3);
        }

        /* Navigation Items */
        .custom-nav-item {
          margin: 0.25rem 0.75rem;
        }

        .custom-nav-item .nav-link {
          padding: 0.75rem 1rem;
          border-radius: 10px;
          color: #cbd5e1;
          transition: all 0.3s ease;
          display: flex;
          align-items: center;
          justify-content: space-between;
          position: relative;
          font-weight: 500;
          font-size: 0.95rem;
        }

        .custom-nav-item .nav-link:hover {
          background: rgba(129, 140, 248, 0.1);
          color: #e0e7ff;
          transform: translateX(4px);
        }

        .custom-nav-item.active .nav-link {
          background: linear-gradient(135deg, rgba(129, 140, 248, 0.15) 0%, rgba(192, 132, 252, 0.15) 100%);
          color: #e0e7ff;
          font-weight: 600;
        }

        .custom-nav-item.active .sidebar-icon {
          color: #818cf8;
        }

        .nav-content {
          display: flex;
          align-items: center;
          gap: 0.75rem;
          flex: 1;
        }

        .sidebar-icon {
          width: 20px;
          display: flex;
          align-items: center;
          justify-content: center;
          color: #94a3b8;
          transition: all 0.3s ease;
        }

        .custom-nav-item:hover .sidebar-icon {
          color: #c4b5fd;
        }

        .sidebar-text {
          font-size: 0.95rem;
        }

        .active-indicator {
          width: 4px;
          height: 20px;
          background: linear-gradient(180deg, #818cf8 0%, #c084fc 100%);
          border-radius: 2px;
          position: absolute;
          right: 0;
        }

        /* Collapsable Items */
        .nav-item-wrapper {
          margin: 0.25rem 0.75rem;
        }

        .nav-item-collapsable {
          padding: 0.75rem 1rem;
          border-radius: 10px;
          color: #cbd5e1;
          cursor: pointer;
          transition: all 0.3s ease;
          display: flex;
          align-items: center;
          justify-content: space-between;
          font-weight: 500;
          font-size: 0.95rem;
        }

        .nav-item-collapsable:hover {
          background: rgba(129, 140, 248, 0.1);
          color: #e0e7ff;
        }

        .nav-item-collapsable.active {
          background: linear-gradient(135deg, rgba(129, 140, 248, 0.15) 0%, rgba(192, 132, 252, 0.15) 100%);
          color: #e0e7ff;
          font-weight: 600;
        }

        .nav-item-collapsable.active .sidebar-icon {
          color: #818cf8;
        }

        .collapse-icon {
          color: #64748b;
          font-size: 0.8rem;
          transition: all 0.3s ease;
        }

        .nav-item-collapsable:hover .collapse-icon {
          color: #c4b5fd;
        }

        /* Submenu */
        .nav-submenu {
          margin-top: 0.5rem;
          padding-left: 2rem;
        }

        .submenu-item {
          margin: 0.15rem 0;
        }

        .submenu-item .nav-link {
          padding: 0.6rem 1rem;
          font-size: 0.9rem;
        }

        .submenu-item .sidebar-icon {
          font-size: 0.75rem;
        }

        /* Divider */
        .border-indigo {
          border-color: rgba(129, 140, 248, 0.2) !important;
          margin: 1.5rem 1.5rem !important;
        }

        /* Logout Item */
        .logout-item {
          margin: 0.25rem 0.75rem;
          margin-top: auto;
        }

        .logout-item .nav-link {
          padding: 0.75rem 1rem;
          border-radius: 10px;
          color: #f87171;
          transition: all 0.3s ease;
          display: flex;
          align-items: center;
          gap: 0.75rem;
          font-weight: 500;
          font-size: 0.95rem;
        }

        .logout-item .nav-link:hover {
          background: rgba(248, 113, 113, 0.1);
          color: #fca5a5;
        }

        .logout-item .sidebar-icon {
          color: #f87171;
        }

        /* Mobile Navbar */
        .navbar-theme-primary {
          background: linear-gradient(90deg, #1e293b 0%, #0f172a 100%) !important;
          box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
        }

        /* Close Button */
        .collapse-close {
          color: #cbd5e1;
          font-size: 1.5rem;
          padding: 0.5rem;
          transition: all 0.3s ease;
        }

        .collapse-close:hover {
          color: #f87171;
        }

        /* Scrollbar Styling */
        .simplebar-scrollbar::before {
          background: rgba(129, 140, 248, 0.5);
          border-radius: 4px;
        }

        .simplebar-track.simplebar-vertical {
          width: 6px;
        }

        /* Responsive */
        @media (max-width: 768px) {
          .sidebar {
            transform: translateX(-100%);
            transition: transform 0.3s ease;
          }

          .sidebar.show {
            transform: translateX(0);
          }
        }

        /* Animation */
        .sidebar-transition-enter {
          opacity: 0;
          transform: translateX(-100%);
        }

        .sidebar-transition-enter-active {
          opacity: 1;
          transform: translateX(0);
          transition: all 300ms ease;
        }

        .sidebar-transition-exit {
          opacity: 1;
          transform: translateX(0);
        }

        .sidebar-transition-exit-active {
          opacity: 0;
          transform: translateX(-100%);
          transition: all 300ms ease;
        }
      `}</style>

      <Navbar expand={false} collapseOnSelect variant="dark" className="navbar-theme-primary px-4 d-md-none">
        <Navbar.Brand className="me-lg-5 py-0">
          <GoLocalBrandMark />
        </Navbar.Brand>
        <Navbar.Toggle as={Button} aria-controls="main-navbar" onClick={onCollapse}>
          <span className="navbar-toggler-icon" />
        </Navbar.Toggle>
      </Navbar>

      <CSSTransition timeout={300} in={show} classNames="sidebar-transition">
        <SimpleBar className={`collapse ${showClass} sidebar d-md-block`}>
          <div className="sidebar-inner">
            
            {/* Mobile User Card */}
            <div className="user-card d-flex d-md-none align-items-center justify-content-between">
              <div className="d-flex align-items-center">
                <div className="user-avatar me-3">
                  <Image src={ProfilePicture} className="card-img-top rounded-circle" style={{ width: '100%', height: '100%', objectFit: 'cover' }} />
                </div>
                <div className="d-block">
                  <h6>Hi, Jane</h6>
                  <Button variant="secondary" size="xs" onClick={handleLogout}>
                    <FontAwesomeIcon icon={faSignOutAlt} className="me-2" /> Sign Out
                  </Button>
                </div>
              </div>
              <Nav.Link className="collapse-close d-md-none" onClick={onCollapse}>
                <FontAwesomeIcon icon={faTimes} />
              </Nav.Link>
            </div>

            {/* Logo */}
            <div className="sidebar-logo">
              <GoLocalBrandMark />
            </div>

            {/* Navigation */}
            <Nav className="flex-column">
              <NavItem title="Users" icon={faUsers} link={Routes.Users.path} />
              
              <NavItem title="Experiences" icon={faGlobeAmericas} link={Routes.Experiences.path} />
              
              <NavItem title="Home Page" icon={faHome} link={Routes.HomeSections.path} />

              <NavItem title="Content" icon={faImage} link={Routes.Content.path} />
              <NavItem title="Reports" icon={faFlag} link={Routes.Reports.path} />
              
              <div className="border-indigo" style={{ borderTop: '1px solid' }} />

              {/* Desktop Logout */}
              <Nav.Item className="logout-item d-none d-md-block" onClick={handleLogout}>
                <Nav.Link>
                  <span className="nav-content">
                    <span className="sidebar-icon">
                      <FontAwesomeIcon icon={faSignOutAlt} />
                    </span>
                    <span className="sidebar-text">Sign Out</span>
                  </span>
                </Nav.Link>
              </Nav.Item>
            </Nav>
          </div>
        </SimpleBar>
      </CSSTransition>
    </>
  );
};